module.exports = __webpack_public_path__ + "static/birmingham-6f81ab9abb6112bfab13410e8f79df4c.png";